import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ThemeService } from '../../../core/services/theme.service';
import { I18nService } from '../../../core/i18n/i18n.service';

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.html',
  styleUrl: './theme-toggle.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeToggle {
  protected readonly themeService = inject(ThemeService);
  private readonly i18n = inject(I18nService);

  protected readonly ariaLabel = computed(() => {
    this.i18n.language();
    this.i18n.messages();
    return this.themeService.isDark()
      ? this.i18n.t('shared.themeToggle.toLight')
      : this.i18n.t('shared.themeToggle.toDark');
  });
}
